import { jsons2arrays } from '@/utils/csv';
import { Header, Row } from '@/utils/xlsx/types';
import * as XLSX from 'xlsx';

interface Data {
    headers: Header[];
    rows: Row[];
}

const getCurrencyFormat = (currency?: string): string => {
    if (!currency) {
        return '#,##0.00';
    }

    const currencySymbols: Record<string, string> = {
        USD: '$',
        EUR: '€',
    };

    const symbol = currencySymbols[currency.toUpperCase()] || currency;
    return `${symbol}#,##0.00`;
};

export const download = (
    data: Data,
    fileName: string,
    options?: { currency?: string },
): void => {
    const worksheet = XLSX.utils.json_to_sheet(
        jsons2arrays(data.rows, data.headers),
    );
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');

    XLSX.utils.sheet_add_aoa(worksheet, [data.headers], {
        origin: 'A1',
    });

    const currencyFormat = getCurrencyFormat(options?.currency);
    const range = XLSX.utils.decode_range(worksheet['!ref'] || 'A1');
    for (let R = range.s.r + 1; R <= range.e.r; ++R) {
        for (let C = range.s.c + 2; C <= range.e.c; ++C) {
            const cellAddress = XLSX.utils.encode_cell({ r: R, c: C });
            const cell = worksheet[cellAddress];
            if (cell && typeof cell.v === 'number') {
                cell.t = 'n';
                cell.z = currencyFormat;
            }
        }
    }

    XLSX.writeFile(workbook, fileName, { compression: true });
};
